(function () {
  var MEMORY_KEY = 'glupotaInpostPickupChoice';
  var PROGUS_POINT_CACHE_KEY = 'inpostPickupSummaryPoint';
  var PROGUS_RATE_CHOICE_KEY = 'inpostDeliveryListChosenRate';
  var PICKUP_ATTRIBUTE_KEYS = [
    'Pickup delivery choice',
    'Wybór dostawy InPost',
    'Pickup point revision',
    'Pickup point carrier',
    'Pickup point country',
    'Pickup point name',
    'Pickup point address',
    'Pickup point coordinates',
    'Paczkomat InPost',
    'Adres Paczkomatu InPost',
    'Współrzędne Paczkomatu InPost',
    'Pickup point payment available',
  ];

  function readMemory() {
    try {
      var memory = JSON.parse(window.sessionStorage.getItem(MEMORY_KEY));

      return memory && memory.point && memory.point.name ? memory : null;
    } catch (error) {
      return null;
    }
  }

  function writeMemory(point, cartAttributes) {
    if (!point || !point.name || !cartAttributes) return;

    var pickupAttributes = {};

    PICKUP_ATTRIBUTE_KEYS.forEach(function (key) {
      if (cartAttributes[key] !== undefined && cartAttributes[key] !== null && cartAttributes[key] !== '') {
        pickupAttributes[key] = cartAttributes[key];
      }
    });

    if (!Object.keys(pickupAttributes).length) return;

    try {
      window.sessionStorage.setItem(
        MEMORY_KEY,
        JSON.stringify({
          attributes: pickupAttributes,
          point: point,
        }),
      );
    } catch (error) {
      // A blocked storage API only disables this convenience; Progus still works.
    }
  }

  function setActionBusy(action, isBusy) {
    action.disabled = isBusy;

    if (typeof action.setAttribute !== 'function' || typeof action.removeAttribute !== 'function') return;

    if (isBusy) action.setAttribute('aria-busy', 'true');
    else action.removeAttribute('aria-busy');
  }

  function restorePickupChoice(memory) {
    return window
      .fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not read cart');
        return response.json();
      })
      .then(function (cart) {
        var attributes = Object.assign({}, cart.attributes || {});

        PICKUP_ATTRIBUTE_KEYS.forEach(function (key) {
          attributes[key] = '';
        });
        Object.assign(attributes, memory.attributes);

        return window.fetch('/cart/update.js', {
          body: JSON.stringify({ attributes: attributes }),
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not restore pickup point');

        window.sessionStorage.setItem(PROGUS_POINT_CACHE_KEY, JSON.stringify(memory.point));
        window.sessionStorage.removeItem(PROGUS_RATE_CHOICE_KEY);
        window.__inpostPickupSelectionLastPickupPoint = memory.point;
        window.dispatchEvent(new Event('pageshow'));
      });
  }

  function handleDeliveryChoice(event) {
    var target = event.target;
    var action = target && typeof target.closest === 'function'
      ? target.closest('[data-inpost-summary-action]')
      : null;

    if (!action) return;

    var actionName = action.getAttribute('data-inpost-summary-action');

    if (actionName === 'choose-rate') {
      writeMemory(
        window.__inpostPickupSelectionLastPickupPoint,
        window.__inpostPickupSelectionLastCartAttributes,
      );
      return;
    }

    if (actionName !== 'select') return;

    var memory = readMemory();
    var carrier = (action.getAttribute('data-inpost-carrier') || '').toLowerCase();
    var pointCarrier = (memory && memory.point.carrierId ? memory.point.carrierId : 'inpost').toLowerCase();

    if (!memory || !carrier || carrier !== pointCarrier) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setActionBusy(action, true);

    restorePickupChoice(memory).catch(function () {
      setActionBusy(action, false);
      action.click();
    });
  }

  window.addEventListener('click', handleDeliveryChoice, true);
})();
